import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken, showToast } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  i18nMessages,
  handleErrorResponseType,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * 任意のタグを削除する
 *
 * @param {string} apiToken - 認証用のAPIトークン。
 * @param {number|string} id - 削除するタグのID。
 * @returns {Function} Redux dispatch関数
 */
const deleteTag = (apiToken, id) => dispatch => {
  consolelog('[API CALL] deleteTag()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_DELETE_TAGS.replace('{id}', id);
  const { cancelToken, cancelTokenKey } = createCancelToken('deleteTag');
  const params = new FormData();
  params.append('cancelToken', cancelToken);
  return axios
    .delete(url, params)
    .then(() => {
      delCancelToken(cancelTokenKey);
      // TODO:タグ削除時のdispatchアクション
      showToast(i18nMessages['toast.message.tag.delete']);
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch, handleErrorResponseType.tags);
      }
      dispatch({
        type: actionTypes.SWITCH_SHOW_MODE_EDIT_MASTER_DIALOG,
        nextShowMode: 'none',
      });
    });
};

export default deleteTag;
